module.exports = __webpack_public_path__ + "img/q18.0988a203.png";